import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" fill="none" fillRule="evenodd"><path d="M7 18.5h10m-10-3h10m-10-3h10m-2.5-10v5h5" /><path d="M19.5 7.5v14h-15v-19h10z" /></g></svg>;